<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-joylearning__revokeuserview}">
      <el-form
        label-width="auto"
        label-position="left"
        :model="dataForm"
      >
        <el-row>
          <el-col :span="24">
            <el-form-item class="grid-content bg-blue">
              <div style="float: left;color: #FFFFFF;margin-top: 2px">
                {{$t('assign.offeringdetail')}}
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <!-- 面授课程 -->
            <el-form-item :label="$t('assign.Facetofacecourses')"
                prop="courseNameCn">
              {{'courseNameCn'}}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <!-- 报名人数 -->
            <el-form-item :label="$t('assign.countuser')"
                prop="applyNumber">
              {{'applyNumber'}}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4">
            <!-- 培训日期 -->
            <el-form-item :label="$t('assign.trainingdate')"
                prop="startdate">
              {{'startdate'}}{{" - "}}
            </el-form-item>
          </el-col>
          <el-col :span="4" style="float:left">
            <el-form-item
                prop="enddate">
              {{'enddate'}}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <!-- 地点 -->
            <el-form-item :label="$t('assign.site')"
                prop="site">
              {{'site'}}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <!-- 撤销报名罚款 -->
            <el-form-item :label="$t('assign.coureschex')"
                prop="coureschex">
              {{'coureschex'}}
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-form
        label-width="auto"
        label-position="right"
        :model="dataForm"
      >
        <el-row>
          <el-col :span="24">
            <el-form-item class="grid-content bg-gray">
              <div style="float: left;margin-top: 2px">
                {{$t('assign.revokeset')}}
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <!-- 撤销学员 -->
            <el-form-item :label="$t('assign.revokeuser')"
                prop="revokeuser">
              {{'revokeuser'}}
            </el-form-item>
          </el-col>
        </el-row>
        <el-form label-position="top"
                :inline="true"
                :model="dataForm">
          <el-row>
            <!-- 请选择撤销原因 -->
            <el-col :span="5">
              <el-form-item :label="$t('assign.revokereason')">
                <el-select :disabled="true"
                  :placeholder="$t('user.select')"
                  clearable>
                  <el-option
                    v-for="(item,index) in revokereasonArr"
                    :key="index"
                    :label="item.name"
                    :value="item.code"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <!-- 意见 -->
            <el-col :span="5">
              <el-form-item :label="$t('assign.opinion')"
                  prop="opinion">
                <el-input class="textarea-input" :disabled="true"
                          v-model="txtrevokeRemark"
                          type="textarea"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-form>
      <div class="search" style="height:150px">
        <ZElButton @click="btnCancel">{{ $t("cancel") }}</ZElButton>
        <el-button @click="btnSave"
                   type="primary">{{ $t("assign.save") }}</el-button>
      </div>
    </div>
  </el-card>
</template>

<script>
import ZElButton from '../../common/button/index'
export default {
  components: { ZElButton },
  data () {
    return {
      txtrevokeRemark: '',
      registeId: ''
    }
  },
  created () {
    this.registeId = this.$route.query.registeId
    console.log('created registeId=' + this.registeId)
  },
  methods: {
    init () {
      console.log('init')
    },
    // 排期信息的回显
    getOfferingInfo (offeringId) {
      console.log('getOfferingInfo registeId=' + this.registeId)
      this.$request.get('/learning/offeringregiste/getOfferingInfo/' + this.registeId).then((res, total, code, data) => {
        console.log(res)
      }).catch((err) => {
        console.log(err)
      })
    },
    // 取消按钮
    btnCancel () {
      this.$confirm('离开本页将不保存当前正在编辑的数据, 确定离开? ', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.tabRemove()
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 删除当前页面
    tabRemove () {
      let tabName = this.$store.state.contentTabsActiveName
      if (tabName === 'home') {
        return false
      }
      this.$store.state.contentTabs = this.$store.state.contentTabs.filter(
        item => item.name !== tabName
      )
      if (this.$store.state.contentTabs.length <= 0) {
        this.$store.state.sidebarMenuActiveName = this.$store.state.contentTabsActiveName =
          'home'
        return false
      }
      // 当前选中tab被删除
      if (tabName === this.$store.state.contentTabsActiveName) {
        this.$router.push({ name: this.$store.state.contentTabs[this.$store.state.contentTabs.length - 1].name })
      }
    }
  }
}
</script>
<style>
  .bg-gray {
    background:#dcdcdc;
  }
  .bg-blue {
    background: #1c69d3;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 30px;
  }
.textarea-input {
  width: 450px;
}
.search {
  margin-bottom: 10px;
}
</style>
